import { FieldError } from "client/lib/apt-merchant";
import hasInstoreChannel from "client/utils/hasInstoreChannel";
import { exactLength } from "utils/validator";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export const bsbErrorMsg =
  "Must be a 6 digit code with a “-” in the middle. Example: 111-000";

export class BsbField extends Field<string> {
  constructor(
    model: Merchant,
    { propertyName }: { propertyName: string },
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "248-069",
      propertyName,
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;

    if (this.propertyName === "bsb2") {
      if (
        registeredCountry === "Australia" &&
        hasInstoreChannel(salesChannel)
      ) {
        return true;
      }
    }

    if (registeredCountry === "Australia") {
      return true;
    }
    return false;
  }

  get required(): boolean {
    if (this.propertyName === "bsb2") {
      const secondaryBankInfo = this._model.secondaryBank;
      // don't require the field when all fields are left blank
      return (
        secondaryBankInfo.fields
          .filter((field) => field.shown)
          .some((field) => field.value) && this.applicable
      );
    }
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    if (typeof this.value === "undefined") return;

    if (!exactLength(7)(this.value)) {
      throw new FieldError(this, bsbErrorMsg, "InvalidLength");
    }
  }
}
